import {
  AlertCircle,
  ArrowDown,
  ArrowUp,
  CheckCircle2,
  Circle,
  Flag,
  Star,
  XCircle,
  type LucideIcon,
} from 'lucide-react';
import { cn } from '@/lib/utils';
import { COLOR_PRESETS } from './formats';
import type { ColorPreset, ConditionalIcon as ConditionalIconName } from './types';

export const CONDITIONAL_ICONS: Array<{ id: ConditionalIconName; label: string; icon: LucideIcon }> = [
  { id: 'circle', label: 'Filled circle', icon: Circle },
  { id: 'check', label: 'Check', icon: CheckCircle2 },
  { id: 'x', label: 'X', icon: XCircle },
  { id: 'alert', label: 'Alert', icon: AlertCircle },
  { id: 'star', label: 'Star', icon: Star },
  { id: 'flag', label: 'Flag', icon: Flag },
  { id: 'arrow-up', label: 'Arrow up', icon: ArrowUp },
  { id: 'arrow-down', label: 'Arrow down', icon: ArrowDown },
];

const ICON_MAP: Record<ConditionalIconName, LucideIcon> = Object.fromEntries(
  CONDITIONAL_ICONS.map((i) => [i.id, i.icon])
) as Record<ConditionalIconName, LucideIcon>;

interface ConditionalIconProps {
  name: ConditionalIconName;
  color: ColorPreset | undefined;
  className?: string;
}

export function ConditionalIcon({ name, color, className }: ConditionalIconProps) {
  const Icon = ICON_MAP[name];
  if (!Icon) return null;
  const isFilledCircle = name === 'circle';
  return (
    <Icon
      className={cn(
        'w-3.5 h-3.5 shrink-0',
        color && COLOR_PRESETS[color].icon,
        isFilledCircle && 'fill-current',
        className
      )}
    />
  );
}
